import { inject, Injectable } from "@angular/core";
import { Widget, WidgetType } from "../models/dashboard.model";
import { WidgetHelperService } from "./widget-helper.service";
import { DisplayService } from "../../home/services/display.service";

@Injectable({
  providedIn: "root",
})
export class DashboardHelperService {
  displayService = inject(DisplayService);

  constructor() {}

  static findFirstEmptyCell(
    widgets: Widget[],
    gridWidth: number,
    widgetType: WidgetType,
  ) {
    const widget = WidgetHelperService.getWidgetSize(widgetType);
    let gridHeight = 8;
    if (widgets.length) {
      gridHeight = Math.max(...widgets.map((widget) => widget.y + widget.h));
    }
    const occupiedCells = new Set<string>();

    widgets.forEach((widget) => {
      for (let i = widget.x; i < widget.x + widget.w; i++) {
        for (let j = widget.y; j < widget.y + widget.h; j++) {
          occupiedCells.add(`${i},${j}`);
        }
      }
    });

    for (let y = 0; y <= gridHeight; y++) {
      for (let x = 0; x < gridWidth; x++) {
        if (
          this.isAreaFree(x, y, widget.w, widget.h, occupiedCells, gridWidth)
        ) {
          return { x, y, h: widget.h, w: widget.w };
        }
      }
    }
  }

  static isAreaFree(
    startX: number,
    startY: number,
    width: number,
    height: number,
    occupiedCells: Set<string>,
    gridWidth: number,
  ): boolean {
    for (let i = startX; i < startX + width; i++) {
      for (let j = startY; j < startY + height; j++) {
        if (i >= gridWidth || occupiedCells.has(`${i},${j}`)) {
          return false;
        }
      }
    }
    return true;
  }
}
